import { BehaviorSubject } from "rxjs";

export class navContentService{
    headerBackground :BehaviorSubject <any>;
    constructor(){
        this.headerBackground = new BehaviorSubject <any>('');
        // this.headerBackground.next("header-blue");
    }
    setHeader(className){
       return this.headerBackground.next(className)
    }

}